import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { JackpotAnalysisPage } from "@/components/JackpotAnalysisPage";
import { jackpotAnalysisFaqs } from "@/data/jackpot-analysis";

const faqs = jackpotAnalysisFaqs("Powerball");

export const Route = createFileRoute("/powerball/jackpot-analysis")({
  head: () =>
    buildSeo({
      title: "Powerball Payout Calculator: State-by-State Lump Sum vs Annuity",
      description:
        "Powerball jackpot analysis: cash value vs annuity, federal and state tax breakdown, and net take-home payouts for all 50 states.",
      path: "/powerball/jackpot-analysis",
      type: "article",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        },
      ],
    }),
  component: () => (
    <JackpotAnalysisPage
      game="Powerball"
      input={{ advertisedJackpot: 100_000_000, cashRatio: 0.49 }}
      faqs={faqs}
      intro="See exactly what a Powerball jackpot pays after federal and state taxes, with a side-by-side comparison of the cash lump sum and the 30-year annuity for every U.S. state."
      drawingsText="Drawings are held Monday, Wednesday, and Saturday at 10:59 PM ET. Tickets cost $2 per play; Power Play multiplier adds $1."
      oddsText="Jackpot odds: 1 in 292,201,338. Overall odds of winning any prize: 1 in 24.87."
    />
  ),
});